@let sp = item();
@if (buttonTitle()) {
  <div class="text-sm text-center font-semibold">{{buttonTitle()}}</div>
}
<div class="flex items-center gap-1 sm:gap-2">
  <div class="text-left w-full h-full">
    <button (click)="pathDescriptionClickedEvent()" class="text-left w-full">
      <div class="font-bold">{{ sp.name }}</div>
      @if (sp.hostName) {
        <div class="">{{ sp.hostName }}</div>
      }
      @if (sp.tagLine) {
        <div class="text-sm font-italic">{{ sp.tagLine }}</div>
      }
    </button>
  </div>
  @if (sp.canPlay || sp.canQueue) {
    <div class="w-10 ml-auto">
      @if (sp.canQueue && false) {
        <div class="text-xl">
          <button (click)="addToQueueEvent()" title="Play Next" class="my-1">
            <fa-icon [icon]="faAdd"></fa-icon>
          </button>
        </div>
      }
      @if (sp.canPlay) {
        <div class="text-xl">
          <button (click)="playNowEvent()" title="Play Now" class="my-1">
            <fa-icon [icon]="faPlay"></fa-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
<div class="text-sm text-left italic hide-on-short line-clamp-3">{{sp.description}}</div>
